import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class ScatterSymbol extends BasicSymbol {

    private lockSpine: PIXI.spine.Spine;
    private scLockSprite: PIXI.Sprite;
    private _symTL: gsap.core.Timeline;


    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {

        super(symbolName, initState, reel, symbolPosition);
        this.isSplitted = false;
        this.load();
        this.getStateAnimation(initState);
        if (symbolName === "SSC") {
            this.isSplitted = true;
        }
        this._symTL = gsap.timeline();

    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        switch (state) {
            case SymbolStates.SPIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.setSpriteTexture("_spin");
                this.moveToNormalLayer();
                break;
            case SymbolStates.START_SPIN:
                if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
                break;
            case SymbolStates.LANDING:
                if (this.symbolName === "SC") {
                    tl.to(this.mainSprite, {alpha: 0, duration: 0.005}, 0.05);
                    tl.add(XwaysHoarder2.screenShake(0.2, 90, false, 15), 0);
                    tl.add(() => {
                        this.setSpriteTexture("");
                        this.mainSpine!.visible = true;
                        this.moveToLockOverlayLayer();
                        /*    if (XwaysHoarder2.model.scatterAnticipationReels.includes(true) && this.reel.id !== 5) {
                                 this.mainSpine!.state.addAnimation(0, "SC Excitement", true, 1.3).timeScale = 1;
                            }*/
                    }, 0.005);
                    tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "SC Attention", false), 0);
                    //scTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "SC Idle", false), ">-0.2");
                    /* if (!XwaysHoarder2.model.scatterAnticipationReels.includes(true)) {
                         scTl.to(this.mainSprite, {alpha: 1, duration: 0.001}, 3.6);

                     }*/
                    // scTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "SC Idle", false));
                    this._symTL = tl;
                }
                break;
            case SymbolStates.NO_WIN:
                if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }
                this.moveToNormalLayer();
                break;
            case SymbolStates.WIN:
                if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }

                tl.add(() => {
                    this.moveToLockOverlayLayer();
                }, 0)
                if (this.symbolName === "SC") {
                    tl.add(this.playSpineAnimation("SC Win"));
                } else if (this.symbolName === "SSC") {
                    tl.add(this.playSpineAnimation("SSC Win"));
                }
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCATTER_WIN);
                }, "<");
                tl.add(() => {
                    this.moveToNormalLayer();
                })
                break;
            case SymbolStates.REVEAL:
                this.state = state;
                this.moveToWinLayer();
            /*    if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }*/
                tl.add(this.playSpineAnimation("SSC Transform"));
                this._symTL = tl;
                break;
            case SymbolStates.REMOVED:
                break;
            case SymbolStates.SCALED:
                break;
            case SymbolStates.SPLIT:
                tl.add(() => {
                    this.state = state;
                }, 0);
                if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }
                tl.add(this.showSplitAnim(), 0);
                this._symTL = tl;
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.STICKY:
                tl.add(() => {
                    this.state = state;
                    this.moveToStickyLayer();
                }, 0);
                if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }
                tl.add(this.lockAnimation(), 0);
                this._symTL = tl;
                break;
            case SymbolStates.UNSTICKY:
                tl.add(() => {
                    this.state = state;
                    this.moveToNormalLayer();
                }, 0);
               /* if (this._symTL.isActive()) {
                    this._symTL.totalProgress(1);
                }*/
                tl.add(this.unlockAnimation(), 0);
                this._symTL = tl;
                break;
            default:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.moveToNormalLayer();
                this.setSpriteTexture("");
        }

        return tl;
    }


    public playSpineAnimation(animName: string): gsap.core.Timeline {
        const playTL: gsap.core.Timeline = gsap.timeline();
        playTL.add(() => {
            this.mainSpine!.visible = true;
            this.mainSprite.alpha = 0;
        }, 0.005);
        playTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, animName, false), 0);
        if (animName !== "SSC Transform") {
            playTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, this.symbolName + " Idle", false));
        }
        return playTL;
    }

    public endScatterLoop(): void {
        if (!this.isSticky) {
            const tl: gsap.core.Timeline = gsap.timeline();
            tl.add(() => {
                this.mainSpine!.state.setAnimation(0, "SC Excitement To Nowin", false).timeScale = 2;
            });
            tl.to(this.mainSprite, {alpha: 1, duration: 0.001}, 0.6);
        }

    }

    private lockAnimation(): gsap.core.Timeline {
        const scLockTl: gsap.core.Timeline = gsap.timeline();
        scLockTl.add(() => {
            this.lockSpine.visible = true;
        }, 0.005);
        scLockTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.lockSpine!, 0, "1x1_Lock", false).timeScale(2), 0);
        scLockTl.add(() => {
            this.scLockSprite.visible = true;
            this.lockSpine.visible = false;
        }, ">");

        return scLockTl;
    }

    private unlockAnimation(): gsap.core.Timeline {
        const scUnlclTL: gsap.core.Timeline = gsap.timeline();
        if (this.state === SymbolStates.STICKY) {
            scUnlclTL.add(() => {
                this.scLockSprite.visible = false;
                this.lockSpine.visible = true;
            }, 0.005);
            scUnlclTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.lockSpine, 0, "1x1_Off", false).timeScale(1), 0);
            scUnlclTL.add(() => {
                this.scLockSprite.visible = false;
                this.lockSpine.visible = false;
            }, ">")
        }
        return scUnlclTL;
    }

    private load(): void {
        this.view.addChild(this.mainSpriteContainer);
        this.setSpine();
        this.view.addChild(this.overlayContainer);
        this.visualHeightStatus = 200;
        this.setLockAssets();
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.symbolSize = 1;//multiplier counter
        this.noWinOverlay = null; //create according to size
    }

    private setSpine(): void {
        this.mainSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SCATTER));
        this.mainSpine.visible = false;
        this.mainSpine.name = `${this.symbolName}mainSpine`;
        this.mainSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.mainSpine);

    }

    private setLockAssets(): void {
        // adding lock assets
        this.lockSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SYM_LOCK));
        this.lockSpine.visible = false;
        this.lockSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);

        this.scLockSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`lock_${this.visualHeightStatus}`)[0]);
        this.scLockSprite.visible = false;
        this.scLockSprite.anchor.set(0.5, 0.5);
        this.scLockSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.scLockSprite, this.lockSpine);
    }


    private showSplitAnim(): gsap.core.Timeline {
        const symSplit: gsap.core.Timeline = gsap.timeline();
        if (!this.isSplitted) {
            this.isSplitted = true;
            this.symbolName = "SSC";
            symSplit.add(() => {
                this.mainSprite.alpha = 0;
            }, 0.005);
            symSplit.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "SC Split", false), 0);
            symSplit.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "SSC Idle", false));
        }
        return symSplit;
    }
}